/*
  Carries the shopper's fitment through to the order.

  The store sells on a fitment guarantee, so after the fact the team has to be
  able to see, per line, which vehicle was saved and what our data told the
  shopper about that part. Two hidden line properties do it:

    _Fitment vehicle   2015 Honda Civic Si   (or "No vehicle set")
    _Fitment verdict   Confirmed             (or Not confirmed, Universal, ...)

  Underscore-prefixed, so Shopify stores them on the line and shows them on the
  order in the admin without ever rendering them to the customer.

  This file handles the FORM-based add paths: the browse and search card
  quick-add, and both product-page rails. The product page builds its cart
  payload by hand rather than from the form, so it stamps its own properties in
  saikospeed-pdp.js, where it can pass the live verdict it is actually
  displaying. Recently Viewed used to post directly and stamp its own; it was
  rebuilt onto `card-product` and now comes through this path like any card,
  which records the same verdict it hardcoded before.

  What gets recorded is what the shopper was SHOWN, not a re-derivation. On a
  card that means the fit line the card rendered: browse surfaces only render
  it when the vehicle filter is applied, which is precisely the case where the
  catalog has confirmed the part for that vehicle. A card with no fit line
  makes no claim, and the record says so rather than guessing.
*/
(function saikospeedFitmentOrder() {
  'use strict';

  var VEHICLE_KEY = '_Fitment vehicle';
  var VERDICT_KEY = '_Fitment verdict';

  function engine() {
    return window.SaikoSpeedFitment || null;
  }

  function setHiddenInput(form, name, value) {
    var existing = form.querySelector('input[data-saiko-fitment-prop="' + name + '"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.setAttribute('data-saiko-fitment-prop', name);
      form.appendChild(existing);
    }
    existing.name = 'properties[' + name + ']';
    existing.value = value;
  }

  /*
    A card claims a fit only when it rendered the browse system's own fit line.
    Reading the card rather than recomputing keeps the record honest: it is
    evidence of what was on screen.
  */
  function verdictFromCard(form) {
    var card = form.closest('.card, .grid-item, .card-product');
    if (!card) return '';
    var fits = card.querySelector('.card-fits-vehicle');
    if (!fits) return '';
    var text = (fits.textContent || '').trim();
    return text ? 'Confirmed' : '';
  }

  function stamp(form) {
    var api = engine();
    if (!api || !form) return;

    var vehicle = api.parseVehicleCookie(document.cookie);
    var cardVerdict = verdictFromCard(form);

    var properties = api.orderProperties({
      vehicle: vehicle,
      status: '',
      // A card that rendered no fit line made no claim, and saying so is more
      // useful to the team than an implied one.
      fallbackVerdict: cardVerdict || (vehicle ? 'Not shown at add' : 'No vehicle set')
    });

    if (cardVerdict) properties[VERDICT_KEY] = cardVerdict;

    setHiddenInput(form, VEHICLE_KEY, properties[VEHICLE_KEY]);
    setHiddenInput(form, VERDICT_KEY, properties[VERDICT_KEY]);
  }

  /*
    Capture phase, because product-form.js reads `new FormData(this.form)` in
    its own submit handler and the inputs have to exist before it runs. A
    bubble-phase listener here would stamp the form after the payload had
    already been built.
  */
  document.addEventListener('submit', function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    stamp(form);
  }, true);
}());
